/**
 * Super-admin content & listings management (TASK-58). From the BestAcco
 * console: action listing submissions, manage property images, create
 * postings/featured content, and manage client media.
 */

// ── Property images ──────────────────────────────────────────────────────────

export interface PropertyImage {
  id: string;
  propertyId: string;
  url: string;
  caption: string | null;
  sortOrder: number;
  isCover: boolean;
  createdAt: string;
}

export interface UpsertPropertyImageRequest {
  propertyId: string;
  url: string;
  caption?: string;
  sortOrder?: number;
  isCover?: boolean;
}

// ── Postings / featured content ──────────────────────────────────────────────

export enum PostingStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
}

export interface Posting {
  id: string;
  title: string;
  slug: string;
  body: string | null;
  heroImageUrl: string | null;
  featured: boolean;
  status: PostingStatus;
  publishedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

// ── Client media ─────────────────────────────────────────────────────────────

export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
  REVIEW = 'review',
}

export interface ClientMedia {
  id: string;
  propertyId: string;
  mediaType: MediaType;
  url: string | null;
  title: string | null;
  body: string | null;
  isApproved: boolean;
  createdAt: string;
}
